import React, { ChangeEvent, FormEvent, useState } from 'react'

import { Text, Input, Button } from 'components'
import { apiUrl } from 'config'
import { getOrganizations } from 'remote/organizations'
import { isDesktop } from 'utils'
import { FormattedMessage } from 'react-intl'

export function SelectByEmail() {
  const [email, setEmail] = useState('')
  const [emailSent, setEmailSent] = useState(false)
  const [emailError, setEmailError] = useState(false)

  const sendEmail = async (event: FormEvent) => {
    event.preventDefault()
    if (!email) {
      return
    }
    setEmailSent(false)
    setEmailError(false)
    try {
      await getOrganizations({
        apiUrl,
        email,
        isDesktop: isDesktop(),
      })
      setEmailSent(true)
    } catch (error) {
      setEmailError(true)
    }
  }

  const onEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    const email = event.target.value
    setEmail(email)
  }

  return emailSent ? (
    <>
      <Text.Section className="margin-bottom-12">
        <FormattedMessage
          id="boarding.org.select.byEmail.inbox"
          defaultMessage="{checked}Check your inbox"
          values={{
            // eslint-disable-next-line formatjs/no-literal-string-in-jsx
            checked: <span className="padding-right-8">✅</span>,
          }}
        />
      </Text.Section>

      <Text.Corpus>
        <FormattedMessage
          id="boarding.org.select.byEmail.description"
          defaultMessage="We’ve sent a link to {email} from where you can join all your teams."
          values={{
            email: <span className="font-weight-medium">{email}</span>,
          }}
        />
      </Text.Corpus>
    </>
  ) : (
    <>
      <Text.Section className="margin-bottom-12">
        <FormattedMessage
          id="boarding.org.select.byEmail.findTeams"
          defaultMessage="Find your teams"
          values={{}}
        />
      </Text.Section>
      <form onSubmit={sendEmail} className="flexbox margin-bottom-12 ">
        <Input
          id="email"
          type="email"
          value={email}
          onChange={onEmailChange}
          className="width-full radius-large"
          placeholder="name@company.com"
        />
        <Button
          variant="primary"
          className="margin-left-12 radius-large"
          disabled={email.length < 1}
          type="submit"
          // eslint-disable-next-line formatjs/no-literal-string-in-jsx
        >
          →
        </Button>
      </form>
      {emailError ? (
        <Text.Corpus className="red-40">
          <FormattedMessage
            id="boarding.org.select.byEmail.error"
            defaultMessage="Error while sending you an email."
            values={{}}
          />
        </Text.Corpus>
      ) : (
        <Text.Corpus className="shade-20">
          <FormattedMessage
            id="boarding.org.select.byEmail.description2"
            defaultMessage="Receive an email with the teams you've joined or can automatically
          join."
            values={{}}
          />
        </Text.Corpus>
      )}
    </>
  )
}
